angular.module('zc.zenclerkS')
  .component('zcsCampaignCreateButton', {
    bindings: {
      project: '<',
    },
    transclude: true,
    templateUrl: '/templates/zenclerk_s/sites/campaigns/create_button/campaign_create_button.html',
    controller: ZcsCampaignCreateButtonCtrl,
  });

ZcsCampaignCreateButtonCtrl.$inject = ['$uibModal', '$state', '$window', 'Campaign', 'ZcsCampaign'];

function ZcsCampaignCreateButtonCtrl($uibModal, $state, $window, Campaign, ZcsCampaign) {
  const vm = this;
  let latestIncompleteCampaign;

  vm.$onInit = () => {
    vm.confirmCampaign = confirmCampaign;
    vm.isAllowedToCreate = () => ZcsCampaign.isAllowedToCreate(vm.project);
    vm.getTooltipMessage = () => ZcsCampaign.getTooltipMessage(vm.project);
  };

  vm.$onChanges = () => {
    if(vm.project) {
      Campaign.all({projectId: vm.project.id})
        .then(campaigns => {
          vm.campaigns = campaigns;
          // find newest incomplete campaign
          latestIncompleteCampaign = _.chain(campaigns)
            .filter(campaign => campaign.status === 'incomplete')
            .filter(campaign => campaign.is_widget === false) // status is false if the campaign is interest widget
            .sortBy(campaign => campaign.create_at)
            .last()
            .value();
        });
    }
  };

  function confirmCampaign() {
    if(!ZcsCampaign.isAllowedToCreate(vm.project)) return;
    if(latestIncompleteCampaign) {
      let modalInstance = $uibModal.open({
        templateUrl: '/templates/zenclerk_s/sites/campaigns/create_button/campaign_confirm_modal.html',
        controller: 'ZcsCampaignConfirmModalController',
        controllerAs: '$ctrl',
        size: 'sm'
      });

      modalInstance.result.then(campaignState => {
        if(campaignState === 'edit') {
          $state.go('zenclerkS.project.campaign.edit.segment', {apikey: latestIncompleteCampaign.apikey, campaignId: latestIncompleteCampaign.id});
        } else if(campaignState === 'new') {
          $state.go('zenclerkS.project.campaign.edit.segment', {apikey: vm.project.apikey, campaignId: 'new'});
        }
      });

    } else {
      $state.go('zenclerkS.project.campaign.edit.segment', {apikey: vm.project.apikey, campaignId: 'new'});
    }
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/sites/campaigns/create_button/campaign_create_button.directive.js